import { useEffect, useState } from "react";

/**
 * Provides a countdown timer that can be started and will decrement every second.
 *
 * @param start The initial value to start the countdown from (default: 10)
 * @returns [isActive, countdown, startCountdown]
 *   - isActive: boolean, true if countdown is running (countdown > 0)
 *   - countdown: number, current countdown value
 *   - startCountdown: function, call to start/reset the countdown
 */
export const useCountdown = (start = 10) => {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown === 0) return;
    const interval = setInterval(() => setCountdown((v) => v - 1), 1000);
    return () => clearInterval(interval);
  }, [countdown]);

  return [countdown > 0, countdown, () => setCountdown(start)] as const;
};
